import { render, staticRenderFns } from "./ALoginForm.vue?vue&type=template&id=48a8a2b0&scoped=true"
import script from "./ALoginForm.vue?vue&type=script&lang=js"
export * from "./ALoginForm.vue?vue&type=script&lang=js"
import style0 from "./ALoginForm.vue?vue&type=style&index=0&id=48a8a2b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a8a2b0",
  null
  
)

export default component.exports